import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import IconArrowUp from "./images/ic_arrow-up.svg";
import IconArrowDown from "./images/ic_arrow-down.svg";
import css from './style.pcss';
var RTLCollapsibleClickbox = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLCollapsibleClickbox, _LitElement);
  function RTLCollapsibleClickbox() {
    _classCallCheck(this, RTLCollapsibleClickbox);
    return _callSuper(this, RTLCollapsibleClickbox); // this.isOpen = false;
  }
  _createClass(RTLCollapsibleClickbox, [{
    key: "render",
    value: function render() {
      var _this = this;
      //console.log("CONTENT", this.content)
      //console.log("CONTENT prased", JSON.parse(this.content));
      //console.log("title prased", JSON.parse(this.title));
      // console.log("CLICKABLE", this.innerText, this.innerHTML)
      var title = this.title;
      if (isJsonString(this.title)) {
        title = JSON.parse(this.title);
      }
      return html(_t || (_t = _`
            <style>${0}</style>
            <div class="clickbox__container">
                <div @click=${0} class="clickbox__header">
                    <div class="clickbox__title">${0}</div>
                    <img class="clickbox__arrow" src=${0} />
                </div>
                <div class="clickbox__content" style=${0}>
                    ${0}
                    <slot></slot>
                </div>
            </div>`), css, function () {
        return _this.isOpen = !_this.isOpen;
      }, unsafeHTML(title), this.isOpen ? IconArrowUp : IconArrowDown, 'display: ' + (this.isOpen ? "block" : "none"), this.content ? unsafeHTML(JSON.parse(this.content)) : null);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        title: {
          type: String
        },
        content: {
          type: String
        },
        isOpen: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLCollapsibleClickbox;
}(LitElement);
export { RTLCollapsibleClickbox as default };
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
window.customElements.define('rtl-collapsible-click-box', RTLCollapsibleClickbox);